import { Component, EventEmitter, Input, OnInit, Output, ViewChildren   } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CqExtraParamsDestination } from 'src/app/beans/components/cq-extra-params/cq-extra-params-destination.bean';
import { CqFileDestination } from 'src/app/beans/components/cq-file/cq-file-destination.bean';
import { CustomValidator } from 'src/app/beans/errors/custom-validator.bean';
import { GuidedCreation } from 'src/app/beans/guided-creation/guided.creation.bean';
import { Hub                        } from 'src/app/beans/hub/hub.bean';
import { User                       } from 'src/app/beans/login/user/user.bean';
import { OperatorLevel } from 'src/app/beans/operator/operator.level.bean';
import { Organization               } from 'src/app/beans/organization/organization.bean';
import { OrganizationDetail         } from 'src/app/beans/organization/organization.detail.bean';
import { Place } from 'src/app/beans/place/place.bean';
import { GenericDialog              } from 'src/app/dialogs/generic/generic.dialog';
import { StepperDialog } from 'src/app/dialogs/stepper/stepper.dialog';
import { AuthLevel } from 'src/app/enums/auth/auth.enum';
import { Levels } from 'src/app/enums/custom/levels.enum';
import { DialogsReturnCode          } from 'src/app/enums/dialogs/returnCode.enum';
import { isSessionCode } from 'src/app/enums/session/session-code.enum';
import { HandlerManager             } from 'src/app/managers/handler/handler.manager';
import { LoadingManager             } from 'src/app/managers/loading/loading.manager';
import { SessionManager             } from 'src/app/managers/session/session.manager';
import { extensionMatch } from 'src/app/validators/extension.validator';
import { genericValidator } from 'src/app/validators/generic.validator';
import { PlaceAutocomplete } from '../../autocomplete/place/place.autocomplete';

@Component
({
  selector: 'organization-data-container',
  templateUrl: './organization.data.container.html',
  styleUrls: ['./organization.data.container.scss']
})

export class OrganizationDataContainer implements OnInit 
{
  public _organization_detail: OrganizationDetail
  public hubs                : Hub  []
  advanced: boolean = false

  public hasQuickOrg: boolean = false

  private organizationId: number

  private autocompleteManager: PlaceAutocomplete
  @ViewChildren('autocompleteManager') set _autocompleteManager(autocompleteManager: PlaceAutocomplete)
  {
    this.autocompleteManager = autocompleteManager
  }  

  @Input('org') set _organization(organization: Organization)
  {    
    if(organization) {
      this.organizationId =  organization.id
      this.hasOrgQuick()
      this.init(organization.id)
    }
  }

  @Output('refresh') refresh: EventEmitter<void> = new EventEmitter()
  //Aggiungere output

  //-------------------------------------------------------------------------

  constructor
  (
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
    private _dialog : MatDialog
  ) {}

  //-------------------------------------------------------------------------

  ngOnInit() {
  }

  async init( organizationId: number )
  {
    if( organizationId )
    {
      this.organizationId       = organizationId
      this.hubs                 = await this.getHubList()
      this._organization_detail = await this.retriveValues( organizationId )
    }
  }

  placeChanged(event: Place) 
  {
    this._organization_detail.placeId   = event.id
    this._organization_detail.placeName = event.name
  }

  isQuickCreateEnabled(){
    const user = this._session.user().get() as User

    if(user && !isSessionCode(user))
    {
      let hub: string

      hub = this._session.hub().get()
     
      if(!hub) return false

      return        user.level == AuthLevel.HUB_MANAGER 
            &&      this.hasQuickOrg
    }

  }


  async hasOrgQuick(){

    let user = this._session.user().get()

    if( !User.isKind( user )) return 

    user = user as User

    const dest: CqExtraParamsDestination = {
      codes   : [ 
        "QCREATE_ORGANIZATION"
      ],
      level   : "OR",
      type    : "WAPP",
      levelid : this.organizationId
    }

    const resp = await this._handler.extraParams().getParamByCode(user.token, dest)
    if(!resp) return 
    this.hasQuickOrg = resp.value1 == "1"
  }
  //-------------------------------------------------------------------------

  update()
  {
    this._organization_detail.enabled = this._organization_detail.enabled ? 1 : 0
    this.openDialog()
  }

  stepCreate()
  {
    this.openStepperDialog()
  }

  openDialog()
  {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus    = true;

    let dialog = this._dialog.open(GenericDialog, dialogConfig);

    dialog.afterClosed().subscribe(async (data) =>
    {
      if(data.code == DialogsReturnCode.OPERATION_ACCEPTED)
      {
        await this.updateOrganization()
        this.refresh.emit()
        //await this.retriveValues(this._organization_detail.id)
      }
    })
  }

  openStepperDialog()
  {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus    = true;

    dialogConfig.data = {
      step: 1,
      quick_type: "org",
      orgId: this.organizationId
    }

    let dialog = this._dialog.open(StepperDialog, dialogConfig);

    dialog.afterClosed().subscribe(async (data) =>
    {
      if(data.code == DialogsReturnCode.OPERATION_ACCEPTED)
      { 
        this.refresh.emit()
      }
    })
  }

  //-------------------------------------------------------------------------

  async retriveValues( organizationId: number ) 
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()

    let response = null
    response = await this._handler.organization().detail((user as User).token, organizationId)

    this._loader.stop()

    if ( !response        ) return
    if ( !response.object ) return

    return response.object as OrganizationDetail;
  }

  async getHubList()
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()

    let response = null
    response = await this._handler.hub().list((user as User).token)

    this._loader.stop()

    if ( !response      ) return
    if ( !response.list ) return

    return response.list as Hub[];
  }
  
  async updateOrganization()
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()

    console.table(this._organization_detail)

    await this._handler.organization().update((user as User).token, this._organization_detail)

    this._loader.stop()
  }

  generateLoginUrl(){
    const href = window.location.href
    try{
      const url = href.split("#")[0]
      return `${url}#/login?code=${this._organization_detail.code}`
    }catch( error ){
      return null
    }
  }

}
